import { jsx as r } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import { Tooltip as n } from "../../tooltip/tooltip.js";
import { useTooltip as l } from "./chart-utils.js";
import t from "clsx";
import e from "../chart.module.less.js";
const C = s(
  function({ className: a, tooltip: m, value: p, ...i }, c) {
    return /* @__PURE__ */ r("div", { className: t(e.percentage, a), ref: c, ...i, children: /* @__PURE__ */ r(n, { as: "div", ...l(m), children: [...Array(100)].map((g, o) => /* @__PURE__ */ r(
      "span",
      {
        className: t(e.percentageDot, {
          [e.percentageFill]: o < +p
        })
      },
      o
    )) }) });
  }
);
export {
  C as ChartPercentage
};
//# sourceMappingURL=chart-percentage.js.map
